import React, {ChangeEvent} from 'react';
import {Choice, FieldProp} from '../../types';

type CheckboxButtonsProps = FieldProp & {};

export const CheckboxButtons: React.FunctionComponent<CheckboxButtonsProps> = ({
                                                                                   field,
                                                                                   fieldState,
                                                                                   value = [],
                                                                                   displayOnly,
                                                                                   onChange,
                                                                                   onBlur,
                                                                               }
): JSX.Element => {
    const {touched, pristine, valid, invalid, errors} = fieldState;

    const classNames = [
        'form-check-input',
        touched && 'is-touched',
        pristine && 'is-pristine',
        valid && 'is-valid',
        invalid && 'is-invalid',
    ]
        .filter(Boolean)
        .join(' ');

    const containerClasses = [
        displayOnly && 'd-flex align-items-stretch pt-2'
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={containerClasses}>
            {field.choices && field.choices.map((choice: Choice, index: number) => {
                const isChecked = (value && value?.find((item: Choice) => item.value === choice.value) !== undefined);
                const displayClasses = [
                    'd-block border pt-1 pb-1 pl-2 pr-2 h-100',
                    'align-items-stretch',
                    isChecked && 'bg-secondary text-white border-dark',
                    !isChecked && 'bg-light text-dark border-secondary'
                ]
                    .filter(Boolean)
                    .join(' ');

                return (
                    <div key={`${field.id}-${index}`}
                         className="form-check">
                        {displayOnly ?
                            <div className={displayClasses}>{choice.text}</div>
                            :
                            <div>
                                <input
                                    id={`${field.id}-${index}`}
                                    className={classNames}
                                    type="checkbox"
                                    value={choice.value}
                                    checked={isChecked}
                                    onBlur={() => {
                                        onBlur && onBlur()
                                    }}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                        if (e.target.checked) {
                                            onChange([...value, choice]);
                                        } else {
                                            onChange(value.filter((item: Choice) => item.value !== choice.value));
                                        }
                                    }}
                                />
                                <label className="form-check-label" htmlFor={`${field.id}-${index}`}>
                                    {choice.text}
                                </label>
                            </div>
                        }
                    </div>
                )
            })}

            {errors && errors.map((error: string, index: number) => (
                <div key={index} className="invalid-feedback">
                    {error}
                </div>
            ))}
        </div>
    );
};